export default "__VITE_ASSET__FbblYWx6__"